module.exports = __webpack_public_path__ + "img/icon.2e2332bb.png";